import { FieldValues, Path, PathValue, UseFormSetValue } from 'react-hook-form';
import { FormComponentProps } from '../types';

interface FormRadioButtonProps<T extends FieldValues> extends FormComponentProps<T> {
  title: string;
  description?: string;
  value: string;
  group: string;
  setValue: UseFormSetValue<T>;
  fieldValue: PathValue<T, Path<T>>;
}

export const FormRadioButton = <T extends FieldValues>(props: FormRadioButtonProps<T>) => {
  const handleSelect = () => {
    if (props.readonly) return;
    props.setValue(props.name, props.value as PathValue<T, Path<T>>);
  };

  const checkedStyling = () => {
    if (props.readonly) {
      return 'checked:border-secondary-deep-blue-30';
    }
    return 'checked:border-solid-bold-green';
  };

  return (
    <div>
      <div className="flex flex-row w-full">
        <input
          onChange={handleSelect}
          disabled={props.readonly}
          checked={props.fieldValue === props.value}
          type="radio"
          className={`translate-y-1 w-4 h-4 border-[2px] rounded-full bg-interactive-bold-green-db-12 border-secondary-deep-blue-30 ${!props.readonly ? 'hover:border-solid-bold-green' : ''} before:w-2 before:h-2 before:rounded-full before:scale-0 before:shadow-radio-button checked:before:scale-[1px] ${checkedStyling()}`}
        />
        <label htmlFor={props.name} className="ml-5 mr-1">
          {props.title}
        </label>
      </div>

      {props.description !== undefined && (
        <span
          className={`block whitespace-pre-wrap mt-3 mb-5 ml-8 mr-8 leading-6 text-sm text-secondary-deep-blue-20 font-italic overflow-hidden transition-[max-height] ease-in duration-300 max-h-0`}
        >
          {props.description}
        </span>
      )}
    </div>
  );
};
